(() => {
  const toggle = document.querySelector('[data-ro-menu-toggle]');
  const menu = document.querySelector('[data-ro-mobile-menu]');
  const close = document.querySelector('[data-ro-menu-close]');

  if (toggle && menu) {
    const openMenu = () => {
      menu.hidden = false;
      document.body.classList.add('ro-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      menu.hidden = true;
      document.body.classList.remove('ro-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', openMenu);
    close?.addEventListener('click', closeMenu);
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const launch = document.querySelector('.ro-launch');

  const chromeMeta = document.querySelector('meta[name="theme-color"]');
  const setThemeColor = (color) => {
    if (!chromeMeta || !color) return;
    chromeMeta.setAttribute('content', color.trim());
  };

  const applyChromeColors = () => {
    if (!launch) return;
    const styles = getComputedStyle(launch);
    const topColor = launch.dataset.roTopColor || styles.getPropertyValue('--phone-top-color') || '#0e0f0c';
    const bottomColor = launch.dataset.roBottomColor || styles.getPropertyValue('--footer-bg') || '#0e0f0c';
    const footer = launch.querySelector('.ro-footer');
    const footerIsVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
    const activeColor = footerIsVisible ? bottomColor : topColor;
    setThemeColor(activeColor);
    document.documentElement.style.backgroundColor = bottomColor.trim();
    document.body.style.backgroundColor = bottomColor.trim();
    document.getElementById('MainContent')?.style.setProperty('background-color', bottomColor.trim());
  };

  applyChromeColors();
  window.addEventListener('scroll', applyChromeColors, { passive: true });
  window.addEventListener('resize', applyChromeColors);
  document.addEventListener('shopify:section:load', () => window.setTimeout(applyChromeColors, 80));
  document.addEventListener('shopify:section:select', () => window.setTimeout(applyChromeColors, 80));

  if (reduceMotion) {
    document.querySelectorAll('.ro-reveal').forEach((item) => item.classList.add('is-in'));
    return;
  }

  const revealItems = [];
  const observedRevealItems = new WeakSet();
  let revealObserver = null;

  const revealItem = (item) => {
    if (item.classList.contains('is-in')) return;
    if (item.classList.contains('ro-paper__quote')) {
      item.classList.add('ro-quote-armed');
      item.getBoundingClientRect();
      window.requestAnimationFrame(() => item.classList.add('is-in'));
      return;
    }
    item.classList.add('is-in');
  };

  const trackRevealItems = (scope = document) => {
    const root = scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.ro-reveal').forEach((item) => {
      if (observedRevealItems.has(item)) return;
      observedRevealItems.add(item);
      revealItems.push(item);
      if (revealObserver) {
        revealObserver.observe(item);
      } else if (!('IntersectionObserver' in window)) {
        revealItem(item);
      }
    });
  };

  const revealVisibleItems = () => {
    const trigger = (window.innerHeight || document.documentElement.clientHeight || 1) * 0.92;
    revealItems.forEach((item) => {
      if (item.classList.contains('is-in')) return;
      const rect = item.getBoundingClientRect();
      if (rect.top <= trigger && rect.bottom >= 0) revealItem(item);
    });
  };

  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealItem(entry.target);
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  }

  trackRevealItems();
  window.addEventListener('scroll', revealVisibleItems, { passive: true });
  window.addEventListener('resize', revealVisibleItems);
  document.addEventListener('shopify:section:load', (event) => {
    trackRevealItems(event.target);
    window.setTimeout(revealVisibleItems, 80);
  });
  document.addEventListener('shopify:section:select', (event) => {
    trackRevealItems(event.target);
    window.setTimeout(revealVisibleItems, 80);
  });
  window.setTimeout(revealVisibleItems, 80);
  revealVisibleItems();

  const parallaxItems = document.querySelectorAll('[data-ro-parallax]');
  let ticking = false;
  const updateParallax = () => {
    ticking = false;
    const source = launch || document.documentElement;
    const strength = parseFloat(getComputedStyle(source).getPropertyValue('--parallax-strength')) || 0;
    if (!strength) return;
    parallaxItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const viewport = window.innerHeight || 1;
      if (rect.bottom < -100 || rect.top > viewport + 100) return;
      const direction = item.dataset.roParallax === 'product' ? -1 : 1;
      const offset = (rect.top + rect.height / 2 - viewport / 2) * strength * -0.18 * direction;
      item.style.setProperty('--ro-parallax-y', `${offset.toFixed(1)}px`);
    });
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }, { passive: true });
  updateParallax();
})();
